export const en = {
  "brand.tagline": "CI control plane",
  "common.refresh": "Refresh",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.close": "Close",
  "common.dismiss": "Dismiss",
  "common.search": "Search",
  "common.actions": "Actions",
  "common.status": "Status",
  "common.created": "Created",
  "common.active": "Active",
  "common.disabled": "Disabled",
  "common.unknown": "Unknown",
  "common.tryAgain": "Try again",
  "common.configuration": "Configuration",
  "common.noDescription": "No description provided.",
  "common.loading": "Loading workspace",
  "common.loadErrorTitle": "Couldn’t load this view",
  "common.unexpectedError": "An unexpected error occurred.",
  "nav.workspace": "Workspace",
  "nav.overview": "Overview",
  "nav.builds": "Builds",
  "nav.pipelines": "Pipelines",
  "nav.sources": "Sources",
  "nav.repositories": "Repositories",
  "nav.security": "Security",
  "nav.primary": "Primary navigation",
  "shell.controlPlane": "Control plane",
  "shell.systemsOnline": "Systems online",
  "shell.localTime": "Local time",
  "shell.operator": "Operator",
  "shell.signOut": "Sign out",
  "shell.openNav": "Open navigation",
  "shell.closeNav": "Close navigation",
  "shell.expandNav": "Expand navigation",
  "shell.collapseNav": "Collapse navigation",
  "shell.lightTheme": "Switch to light theme",
  "shell.darkTheme": "Switch to dark theme",
  "shell.settings": "Settings",
  "shell.secureSession": "Resolving secure session…",
  "settings.title": "Settings",
  "settings.subtitle": "Personalize your Lumina workspace.",
  "settings.language": "Language",
  "settings.languageHint": "Changes every console label immediately.",
  "settings.english": "English",
  "settings.russian": "Русский",
  "settings.appearance": "Appearance",
  "settings.appearanceHint": "Follow your device or choose a fixed theme.",
  "settings.system": "System",
  "settings.dark": "Dark",
  "settings.light": "Light",
  "settings.density": "Layout density",
  "settings.densityHint": "Compact mode fits more operational data on screen.",
  "settings.comfortable": "Comfortable",
  "settings.compact": "Compact",
  "settings.refresh": "Live refresh",
  "settings.refreshHint": "Automatically refresh active operational views.",
  "settings.off": "Off",
  "settings.seconds": "{count} sec",
  "settings.persisted": "Preferences are saved only in this browser.",
  "login.about": "About Lumina CI",
  "login.eyebrow": "Trusted delivery infrastructure",
  "login.headline1": "Build software",
  "login.headline2": "with clarity.",
  "login.story": "One secure control plane for source provenance, reproducible builds, signing, scanning, and package delivery.",
  "login.policy": "Policy enforced",
  "login.signed": "Signed artifacts",
  "login.private": "Private by default",
  "login.workspace": "operational workspace",
  "login.secureConsole": "Secure console",
  "login.welcome": "Welcome back",
  "login.continue": "Use your Lumina operator account to continue.",
  "login.username": "Username",
  "login.password": "Password",
  "login.usernamePlaceholder": "operator",
  "login.passwordPlaceholder": "Enter your password",
  "login.authenticating": "Authenticating…",
  "login.signIn": "Sign in",
  "login.error": "Unable to sign in. Check your credentials.",
  "login.security": "Credentials are sent over the secure same-origin session and never stored in the browser.",
  "dashboard.eyebrow": "Overview",
  "dashboard.title": "Delivery pulse",
  "dashboard.description": "Build health, executor activity, and release throughput at a glance.",
  "dashboard.startBuild": "Start a build",
  "dashboard.loading": "Loading delivery pulse",
  "dashboard.statsLabel": "Build statistics",
  "dashboard.totalBuilds": "Total builds",
  "dashboard.totalDetail": "All recorded executions",
  "dashboard.successRate": "Success rate",
  "dashboard.successful": "{count} successful",
  "dashboard.activeWork": "Active work",
  "dashboard.waiting": "{count} waiting in queue",
  "dashboard.risk": "High risk findings",
  "dashboard.riskDetail": "Critical and high CVEs",
  "dashboard.executionStream": "Execution stream",
  "dashboard.recentBuilds": "Recent builds",
  "dashboard.viewAll": "View all",
  "dashboard.noBuilds": "No builds yet",
  "dashboard.noBuildsDetail": "Run a pipeline to begin tracking delivery activity.",
  "dashboard.executors": "Executors",
  "dashboard.queue": "Build queue",
  "dashboard.running": "Running",
  "dashboard.queued": "Queued",
  "dashboard.activeBuilds": "{count} active builds",
  "dashboard.idle": "Executors are idle and ready.",
  "dashboard.definitions": "Definitions",
  "dashboard.inventory": "Pipeline inventory",
  "dashboard.manage": "Manage pipelines",
  "dashboard.steps": "{count} steps",
  "builds.eyebrow": "Execution history",
  "builds.title": "Builds",
  "builds.description": "Inspect every package build, from queued work to verified artifacts.",
  "builds.clearQueue": "Clear queue",
  "builds.clearConfirm": "Remove all queued builds? Running builds will not be affected.",
  "builds.cleared": "Queued builds cleared.",
  "builds.filter": "Filter builds",
  "builds.all": "All",
  "builds.loading": "Loading build history",
  "builds.caption": "Build history",
  "builds.build": "Build",
  "builds.pipeline": "Pipeline",
  "builds.triggeredBy": "Triggered by",
  "builds.page": "{count} builds · page {page} of {pages}",
  "builds.none": "No matching builds",
  "builds.noneDetail": "There are no build executions in this state.",
  "builds.runPipeline": "Run a pipeline",
  "builds.inspect": "Inspect {name}",
  "buildDetail.back": "Build history",
  "buildDetail.eyebrow": "Build execution",
  "buildDetail.title": "Build {id}",
  "buildDetail.description": "Live stages, provenance, logs, and artifact verification.",
  "buildDetail.cancel": "Cancel build",
  "buildDetail.cancelConfirm": "Cancel this build execution?",
  "buildDetail.cancelled": "Cancellation requested.",
  "buildDetail.loading": "Resolving build execution",
  "buildDetail.current": "Current state",
  "buildDetail.triggered": "Triggered by",
  "buildDetail.duration": "Duration",
  "buildDetail.durationValue": "{minutes}m {seconds}s",
  "buildDetail.notStarted": "Not started",
  "buildDetail.commit": "Commit",
  "buildDetail.target": "Target",
  "buildDetail.defaultProfile": "Default profile",
  "buildDetail.graph": "Execution graph",
  "buildDetail.stages": "Pipeline stages",
  "buildDetail.legacy": "Legacy build",
  "buildDetail.singleStage": "Single-stage execution",
  "buildDetail.output": "Live output",
  "buildDetail.logs": "Build logs",
  "buildDetail.copy": "Copy",
  "buildDetail.waitingLogs": "Waiting for executor output…",
  "buildDetail.supplyChain": "Supply chain",
  "buildDetail.artifacts": "Artifacts",
  "buildDetail.signed": "Signed",
  "buildDetail.unsigned": "Unsigned",
  "buildDetail.download": "Download {name}",
  "buildDetail.noArtifacts": "No artifacts yet",
  "buildDetail.noArtifactsDetail": "Artifacts will appear after the build and verification stages complete.",
  "pipelines.eyebrow": "Build definitions",
  "pipelines.title": "Pipelines",
  "pipelines.description": "Create repeatable delivery paths from source to signed package.",
  "pipelines.new": "New pipeline",
  "pipelines.searchPlaceholder": "Search pipelines by name…",
  "pipelines.clearSearch": "Clear search",
  "pipelines.loading": "Loading pipeline definitions",
  "pipelines.source": "Source",
  "pipelines.manualSpec": "Manual specification",
  "pipelines.stages": "Stages",
  "pipelines.owner": "Owner",
  "pipelines.run": "Run build",
  "pipelines.edit": "Edit",
  "pipelines.delete": "Delete {name}",
  "pipelines.more": "More actions for {name}",
  "pipelines.deleteConfirm": "Delete pipeline “{name}”? This cannot be undone.",
  "pipelines.deleted": "{name} deleted.",
  "pipelines.saved": "Pipeline saved.",
  "pipelines.startError": "Unable to start build.",
  "pipelines.none": "No pipelines found",
  "pipelines.noneSearch": "Try a different search term.",
  "pipelines.noneDetail": "Create a pipeline to define your first repeatable build.",
  "pipelines.create": "Create pipeline",
  "pipelines.editTitle": "Edit {name}",
  "pipelines.name": "Pipeline name",
  "pipelines.namePlaceholder": "release-packages",
  "pipelines.formDescription": "Description",
  "pipelines.descriptionPlaceholder": "What this delivery pipeline produces",
  "pipelines.gitUrl": "Git repository URL",
  "pipelines.webhookSecret": "Webhook secret",
  "pipelines.webhookHint": "Save this generated secret in your Git provider; it cannot be retrieved later.",
  "pipelines.branch": "Branch",
  "pipelines.specPath": "Spec path",
  "pipelines.triggerPaths": "Webhook path prefixes",
  "pipelines.triggerPathsHint": "Only pushes changing one of these repository-relative paths trigger this pipeline. Defaults to the spec directory.",
  "pipelines.distribution": "Distribution",
  "pipelines.release": "Release",
  "pipelines.architecture": "Architecture",
  "pipelines.buildImage": "Build image",
  "pipelines.defaultImage": "Default approved image",
  "pipelines.saving": "Saving…",
  "pipelines.save": "Save pipeline",
  "pipelines.saveError": "Unable to save pipeline.",
  "repositories.eyebrow": "Package distribution",
  "repositories.title": "Repositories",
  "repositories.description": "Publish trusted RPMs into architecture-specific package channels.",
  "repositories.new": "New repository",
  "repositories.loading": "Loading package repositories",
  "repositories.packages": "packages available",
  "repositories.distribution": "Distribution",
  "repositories.architecture": "Architecture",
  "repositories.sync": "Sync metadata",
  "repositories.syncStarted": "{name} metadata sync started.",
  "repositories.none": "No repositories configured",
  "repositories.noneDetail": "Create a repository to begin publishing verified packages.",
  "repositories.create": "Create repository",
  "repositories.created": "Repository created.",
  "repositories.name": "Name",
  "repositories.displayName": "Display name",
  "repositories.basePath": "Base path",
  "repositories.error": "Unable to create repository.",
  "security.eyebrow": "Supply chain trust",
  "security.title": "Security",
  "security.description": "Track signatures, integrity records, and vulnerability intelligence.",
  "security.generate": "Generate key",
  "security.loading": "Loading security posture",
  "security.signingKeys": "Signing keys",
  "security.identities": "Managed trust identities",
  "security.critical": "Critical CVEs",
  "security.criticalDetail": "Require immediate attention",
  "security.high": "High CVEs",
  "security.highDetail": "Across recent scans",
  "security.intelligence": "Vulnerability intelligence",
  "security.recentScans": "Recent scans",
  "security.scanCaption": "Recent vulnerability scans",
  "security.artifact": "Artifact",
  "security.scanner": "Scanner",
  "security.findings": "Findings",
  "security.completed": "Completed",
  "security.criticalCount": "{count} critical",
  "security.highCount": "{count} high",
  "security.noScans": "No scans recorded",
  "security.noScansDetail": "Vulnerability results appear after an artifact reaches the scan stage.",
  "security.integrity": "Artifact integrity",
  "security.hashLedger": "Hash ledger",
  "security.hashCaption": "Artifact hash records",
  "security.computed": "Computed",
  "security.noHashes": "No hash records",
  "security.noHashesDetail": "Verified digests will appear here after artifacts are produced.",
  "security.requested": "Signing key generation requested.",
  "security.keyName": "Key name",
  "security.keyPlaceholder": "Lumina release signing",
  "security.email": "Identity email",
  "security.error": "Unable to generate key.",
  "sources.eyebrow": "Source provenance",
  "sources.title": "Sources",
  "sources.description": "Pin, revision, and fetch package inputs through a durable source catalog.",
  "sources.add": "Add source",
  "sources.loading": "Loading source catalog",
  "sources.pinned": "SHA-256 pinned",
  "sources.fetched": "Fetched {date}",
  "sources.neverFetched": "Never fetched",
  "sources.fetch": "Fetch",
  "sources.fetchQueued": "Fetch queued for {name}.",
  "sources.edit": "Edit {name}",
  "sources.disable": "Disable {name}",
  "sources.disableConfirm": "Disable {name}?",
  "sources.disabled": "{name} disabled.",
  "sources.none": "No package sources yet",
  "sources.noneDetail": "Add a package once; Lumina will validate, revision, and fetch it automatically.",
  "sources.addFirst": "Add first source",
  "sources.saved": "Source saved and queued for fetch.",
  "sources.addPackage": "Add package source",
  "sources.packageSlug": "Package slug",
  "sources.sourceType": "Source type",
  "sources.sourceUrl": "HTTPS source URL",
  "sources.reference": "Branch, tag, or commit",
  "sources.sha": "Expected SHA-256",
  "sources.specPath": "Spec path",
  "sources.imageOverride": "Build image override",
  "sources.fetchAutomatically": "Fetch automatically after saving",
  "sources.saveFetch": "Save and fetch",
  "sources.error": "Unable to save source.",
  "status.Queued": "Queued",
  "status.Building": "Building",
  "status.Success": "Success",
  "status.Failed": "Failed",
  "status.Cancelled": "Cancelled",
  "status.Draft": "Draft",
  "status.Active": "Active",
  "status.Disabled": "Disabled",
  "status.Paused": "Paused",
  "status.Archived": "Archived",
  "status.Pending": "Pending",
  "status.Running": "Running",
  "status.Clean": "Clean",
  "status.Vulnerable": "Vulnerable",
  "status.Error": "Error",
  "status.Completed": "Completed",
  "status.Skipped": "Skipped",
  "status.Fetching": "Fetching",
  "status.Ready": "Ready",
  "status.Signed": "Signed",
  "status.Unsigned": "Unsigned"
} as const;

export type TranslationKey = keyof typeof en;
export type TranslationDictionary = Record<TranslationKey, string>;

export const ru: TranslationDictionary = {
  ...en,
  "brand.tagline": "панель управления CI",
  "common.refresh": "Обновить",
  "common.cancel": "Отмена",
  "common.save": "Сохранить",
  "common.close": "Закрыть",
  "common.dismiss": "Скрыть",
  "common.search": "Поиск",
  "common.actions": "Действия",
  "common.status": "Статус",
  "common.created": "Создано",
  "common.active": "Активен",
  "common.disabled": "Отключён",
  "common.unknown": "Неизвестно",
  "common.tryAgain": "Повторить",
  "common.configuration": "Настройка",
  "common.noDescription": "Описание не указано.",
  "common.loading": "Загрузка рабочего пространства",
  "common.loadErrorTitle": "Не удалось загрузить раздел",
  "common.unexpectedError": "Произошла непредвиденная ошибка.",
  "nav.workspace": "Рабочее пространство",
  "nav.overview": "Обзор",
  "nav.builds": "Сборки",
  "nav.pipelines": "Пайплайны",
  "nav.sources": "Исходники",
  "nav.repositories": "Репозитории",
  "nav.security": "Безопасность",
  "nav.primary": "Основная навигация",
  "shell.controlPlane": "Панель управления",
  "shell.systemsOnline": "Системы в норме",
  "shell.localTime": "Местное время",
  "shell.operator": "Оператор",
  "shell.signOut": "Выйти",
  "shell.openNav": "Открыть навигацию",
  "shell.closeNav": "Закрыть навигацию",
  "shell.expandNav": "Развернуть навигацию",
  "shell.collapseNav": "Свернуть навигацию",
  "shell.lightTheme": "Включить светлую тему",
  "shell.darkTheme": "Включить тёмную тему",
  "shell.settings": "Настройки",
  "shell.secureSession": "Проверяем защищённую сессию…",
  "settings.title": "Настройки",
  "settings.subtitle": "Настройте Lumina под себя.",
  "settings.language": "Язык",
  "settings.languageHint": "Все подписи в консоли изменятся сразу.",
  "settings.english": "English",
  "settings.russian": "Русский",
  "settings.appearance": "Оформление",
  "settings.appearanceHint": "Следуйте настройкам устройства или выберите тему.",
  "settings.system": "Системная",
  "settings.dark": "Тёмная",
  "settings.light": "Светлая",
  "settings.density": "Плотность интерфейса",
  "settings.densityHint": "Компактный режим показывает больше рабочих данных.",
  "settings.comfortable": "Обычная",
  "settings.compact": "Компактная",
  "settings.refresh": "Автообновление",
  "settings.refreshHint": "Автоматически обновлять активные рабочие разделы.",
  "settings.off": "Выкл.",
  "settings.seconds": "{count} сек.",
  "settings.persisted": "Настройки сохраняются только в этом браузере.",
  "login.about": "О Lumina CI",
  "login.eyebrow": "Надёжная инфраструктура поставки",
  "login.headline1": "Создавайте ПО",
  "login.headline2": "с ясностью.",
  "login.story": "Единая защищённая панель для исходников, воспроизводимых сборок, подписания, сканирования и публикации пакетов.",
  "login.policy": "Политики соблюдены",
  "login.signed": "Подписанные артефакты",
  "login.private": "Закрыто по умолчанию",
  "login.workspace": "рабочее пространство",
  "login.secureConsole": "Защищённая консоль",
  "login.welcome": "С возвращением",
  "login.continue": "Войдите под учётной записью оператора Lumina.",
  "login.username": "Имя пользователя",
  "login.password": "Пароль",
  "login.usernamePlaceholder": "оператор",
  "login.passwordPlaceholder": "Введите пароль",
  "login.authenticating": "Проверяем данные…",
  "login.signIn": "Войти",
  "login.error": "Не удалось войти. Проверьте имя пользователя и пароль.",
  "login.security": "Данные передаются внутри защищённой сессии и не сохраняются в браузере.",
  "dashboard.eyebrow": "Обзор",
  "dashboard.title": "Пульс поставки",
  "dashboard.description": "Состояние сборок, активность исполнителей и выпуск пакетов.",
  "dashboard.startBuild": "Запустить сборку",
  "dashboard.loading": "Загрузка состояния поставки",
  "dashboard.statsLabel": "Статистика сборок",
  "dashboard.totalBuilds": "Всего сборок",
  "dashboard.totalDetail": "Все зарегистрированные запуски",
  "dashboard.successRate": "Успешность",
  "dashboard.successful": "Успешных: {count}",
  "dashboard.activeWork": "Активные задачи",
  "dashboard.waiting": "В очереди: {count}",
  "dashboard.risk": "Опасные находки",
  "dashboard.riskDetail": "Критические и высокие CVE",
  "dashboard.executionStream": "Поток выполнения",
  "dashboard.recentBuilds": "Последние сборки",
  "dashboard.viewAll": "Показать все",
  "dashboard.noBuilds": "Сборок пока нет",
  "dashboard.noBuildsDetail": "Запустите пайплайн, чтобы увидеть историю поставки.",
  "dashboard.executors": "Исполнители",
  "dashboard.queue": "Очередь сборок",
  "dashboard.running": "Выполняются",
  "dashboard.queued": "В очереди",
  "dashboard.activeBuilds": "Активных сборок: {count}",
  "dashboard.idle": "Исполнители свободны и готовы к работе.",
  "dashboard.definitions": "Конфигурации",
  "dashboard.inventory": "Пайплайны",
  "dashboard.manage": "Управлять пайплайнами",
  "dashboard.steps": "Этапов: {count}",
  "builds.eyebrow": "История выполнения",
  "builds.title": "Сборки",
  "builds.description": "Все сборки пакетов: от очереди до проверенных артефактов.",
  "builds.clearQueue": "Очистить очередь",
  "builds.clearConfirm": "Удалить все ожидающие сборки? Выполняемые сборки продолжат работу.",
  "builds.cleared": "Очередь сборок очищена.",
  "builds.filter": "Фильтр сборок",
  "builds.all": "Все",
  "builds.loading": "Загрузка истории сборок",
  "builds.caption": "История сборок",
  "builds.build": "Сборка",
  "builds.pipeline": "Пайплайн",
  "builds.triggeredBy": "Запустил",
  "builds.page": "Сборок: {count} · страница {page} из {pages}",
  "builds.none": "Подходящих сборок нет",
  "builds.noneDetail": "В выбранном состоянии сборок нет.",
  "builds.runPipeline": "Запустить пайплайн",
  "builds.inspect": "Открыть {name}",
  "buildDetail.back": "История сборок",
  "buildDetail.eyebrow": "Выполнение сборки",
  "buildDetail.title": "Сборка {id}",
  "buildDetail.description": "Этапы, происхождение, журналы и проверка артефактов.",
  "buildDetail.cancel": "Отменить сборку",
  "buildDetail.cancelConfirm": "Отменить выполнение этой сборки?",
  "buildDetail.cancelled": "Запрошена отмена сборки.",
  "buildDetail.loading": "Загрузка сборки",
  "buildDetail.current": "Текущее состояние",
  "buildDetail.triggered": "Запустил",
  "buildDetail.duration": "Длительность",
  "buildDetail.durationValue": "{minutes} мин {seconds} с",
  "buildDetail.notStarted": "Не началась",
  "buildDetail.commit": "Коммит",
  "buildDetail.target": "Цель",
  "buildDetail.defaultProfile": "Профиль по умолчанию",
  "buildDetail.graph": "Граф выполнения",
  "buildDetail.stages": "Этапы пайплайна",
  "buildDetail.legacy": "Старая сборка",
  "buildDetail.singleStage": "Одноэтапное выполнение",
  "buildDetail.output": "Вывод в реальном времени",
  "buildDetail.logs": "Журнал сборки",
  "buildDetail.copy": "Копировать",
  "buildDetail.waitingLogs": "Ожидаем вывод исполнителя…",
  "buildDetail.supplyChain": "Цепочка поставки",
  "buildDetail.artifacts": "Артефакты",
  "buildDetail.signed": "Подписан",
  "buildDetail.unsigned": "Не подписан",
  "buildDetail.download": "Скачать {name}",
  "buildDetail.noArtifacts": "Артефактов пока нет",
  "buildDetail.noArtifactsDetail": "Артефакты появятся после завершения сборки и проверок.",
  "pipelines.eyebrow": "Конфигурации сборок",
  "pipelines.title": "Пайплайны",
  "pipelines.description": "Создавайте повторяемые пути от исходников до подписанного пакета.",
  "pipelines.new": "Новый пайплайн",
  "pipelines.searchPlaceholder": "Поиск пайплайнов по имени…",
  "pipelines.clearSearch": "Очистить поиск",
  "pipelines.loading": "Загрузка пайплайнов",
  "pipelines.source": "Источник",
  "pipelines.manualSpec": "Спецификация вручную",
  "pipelines.stages": "Этапы",
  "pipelines.owner": "Владелец",
  "pipelines.run": "Запустить",
  "pipelines.edit": "Изменить",
  "pipelines.delete": "Удалить {name}",
  "pipelines.more": "Дополнительные действия: {name}",
  "pipelines.deleteConfirm": "Удалить пайплайн «{name}»? Это действие нельзя отменить.",
  "pipelines.deleted": "{name} удалён.",
  "pipelines.saved": "Пайплайн сохранён.",
  "pipelines.startError": "Не удалось запустить сборку.",
  "pipelines.none": "Пайплайны не найдены",
  "pipelines.noneSearch": "Попробуйте другой запрос.",
  "pipelines.noneDetail": "Создайте первый повторяемый сценарий сборки.",
  "pipelines.create": "Создать пайплайн",
  "pipelines.editTitle": "Изменить {name}",
  "pipelines.name": "Название пайплайна",
  "pipelines.namePlaceholder": "release-packages",
  "pipelines.formDescription": "Описание",
  "pipelines.descriptionPlaceholder": "Что создаёт этот пайплайн",
  "pipelines.gitUrl": "URL Git-репозитория",
  "pipelines.webhookSecret": "Секрет вебхука",
  "pipelines.webhookHint": "Сохраните созданный секрет в Git-провайдере: позже получить его нельзя.",
  "pipelines.branch": "Ветка",
  "pipelines.specPath": "Путь к spec-файлу",
  "pipelines.triggerPaths": "Префиксы путей для вебхука",
  "pipelines.triggerPathsHint": "Пайплайн запускается только при изменении одного из этих путей в репозитории. По умолчанию используется каталог spec-файла.",
  "pipelines.distribution": "Дистрибутив",
  "pipelines.release": "Релиз",
  "pipelines.architecture": "Архитектура",
  "pipelines.buildImage": "Образ сборки",
  "pipelines.defaultImage": "Разрешённый образ по умолчанию",
  "pipelines.saving": "Сохраняем…",
  "pipelines.save": "Сохранить пайплайн",
  "pipelines.saveError": "Не удалось сохранить пайплайн.",
  "repositories.eyebrow": "Распространение пакетов",
  "repositories.title": "Репозитории",
  "repositories.description": "Публикуйте доверенные RPM в каналы для нужных архитектур.",
  "repositories.new": "Новый репозиторий",
  "repositories.loading": "Загрузка репозиториев",
  "repositories.packages": "пакетов доступно",
  "repositories.distribution": "Дистрибутив",
  "repositories.architecture": "Архитектура",
  "repositories.sync": "Синхронизировать",
  "repositories.syncStarted": "Синхронизация метаданных {name} запущена.",
  "repositories.none": "Репозитории не настроены",
  "repositories.noneDetail": "Создайте репозиторий для публикации проверенных пакетов.",
  "repositories.create": "Создать репозиторий",
  "repositories.created": "Репозиторий создан.",
  "repositories.name": "Имя",
  "repositories.displayName": "Отображаемое имя",
  "repositories.basePath": "Базовый путь",
  "repositories.error": "Не удалось создать репозиторий.",
  "security.eyebrow": "Доверие к цепочке поставки",
  "security.title": "Безопасность",
  "security.description": "Подписи, контроль целостности и сведения об уязвимостях.",
  "security.generate": "Создать ключ",
  "security.loading": "Загрузка состояния безопасности",
  "security.signingKeys": "Ключи подписи",
  "security.identities": "Управляемые доверенные идентификаторы",
  "security.critical": "Критические CVE",
  "security.criticalDetail": "Требуют немедленного внимания",
  "security.high": "Высокие CVE",
  "security.highDetail": "В последних сканированиях",
  "security.intelligence": "Сведения об уязвимостях",
  "security.recentScans": "Последние сканирования",
  "security.scanCaption": "Последние сканирования уязвимостей",
  "security.artifact": "Артефакт",
  "security.scanner": "Сканер",
  "security.findings": "Находки",
  "security.completed": "Завершено",
  "security.criticalCount": "Критических: {count}",
  "security.highCount": "Высоких: {count}",
  "security.noScans": "Сканирований пока нет",
  "security.noScansDetail": "Результаты появятся после этапа сканирования артефакта.",
  "security.integrity": "Целостность артефактов",
  "security.hashLedger": "Реестр хешей",
  "security.hashCaption": "Хеши артефактов",
  "security.computed": "Вычислено",
  "security.noHashes": "Хешей пока нет",
  "security.noHashesDetail": "Проверенные хеши появятся после создания артефактов.",
  "security.requested": "Запрошено создание ключа подписи.",
  "security.keyName": "Название ключа",
  "security.keyPlaceholder": "Ключ подписи релизов Lumina",
  "security.email": "Email идентификатора",
  "security.error": "Не удалось создать ключ.",
  "sources.eyebrow": "Происхождение исходников",
  "sources.title": "Исходники",
  "sources.description": "Фиксируйте версии и загружайте входные данные из надёжного каталога.",
  "sources.add": "Добавить источник",
  "sources.loading": "Загрузка каталога исходников",
  "sources.pinned": "Зафиксирован SHA-256",
  "sources.fetched": "Загружено {date}",
  "sources.neverFetched": "Ещё не загружалось",
  "sources.fetch": "Загрузить",
  "sources.fetchQueued": "{name}: загрузка поставлена в очередь.",
  "sources.edit": "Изменить {name}",
  "sources.disable": "Отключить {name}",
  "sources.disableConfirm": "Отключить {name}?",
  "sources.disabled": "{name} отключён.",
  "sources.none": "Источников пакетов пока нет",
  "sources.noneDetail": "Добавьте пакет один раз — Lumina проверит, версионирует и загрузит его.",
  "sources.addFirst": "Добавить первый источник",
  "sources.saved": "Источник сохранён и поставлен в очередь.",
  "sources.addPackage": "Добавить источник пакета",
  "sources.packageSlug": "Идентификатор пакета",
  "sources.sourceType": "Тип источника",
  "sources.sourceUrl": "HTTPS URL источника",
  "sources.reference": "Ветка, тег или коммит",
  "sources.sha": "Ожидаемый SHA-256",
  "sources.specPath": "Путь к spec-файлу",
  "sources.imageOverride": "Другой образ сборки",
  "sources.fetchAutomatically": "Загрузить автоматически после сохранения",
  "sources.saveFetch": "Сохранить и загрузить",
  "sources.error": "Не удалось сохранить источник.",
  "status.Queued": "В очереди",
  "status.Building": "Собирается",
  "status.Success": "Успешно",
  "status.Failed": "Ошибка",
  "status.Cancelled": "Отменено",
  "status.Draft": "Черновик",
  "status.Active": "Активен",
  "status.Disabled": "Отключён",
  "status.Paused": "Приостановлен",
  "status.Archived": "В архиве",
  "status.Pending": "Ожидает",
  "status.Running": "Выполняется",
  "status.Clean": "Чисто",
  "status.Vulnerable": "Уязвим",
  "status.Error": "Ошибка",
  "status.Completed": "Завершено",
  "status.Skipped": "Пропущено",
  "status.Fetching": "Загружается",
  "status.Ready": "Готов",
  "status.Signed": "Подписан",
  "status.Unsigned": "Не подписан"
};
